import { createPortal } from 'react-dom'
import Modal from '../../../ui/Modal'

interface RemoveNodeConfirmationModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function RemoveNodeConfirmationModal({
  isOpen,
  onCancel,
  onConfirm,
}: RemoveNodeConfirmationModalProps) {
  if (!isOpen) return null

  return createPortal(
    <Modal isOpen={isOpen} onClose={onCancel} title="Remove Node" size="sm">
      <p className="mb-4 text-sm text-muted-foreground">
        Remove this node from the canvas?
      </p>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="h-9 rounded-lg border border-input-border bg-surface-1 px-3 text-sm text-foreground transition-colors hover:border-input-border-hover hover:bg-surface-3 focus:outline-none focus:ring-2 focus:ring-primary/20"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="h-9 rounded-lg bg-destructive px-3 text-sm font-medium text-white transition-colors hover:bg-destructive/90 focus:outline-none focus:ring-2 focus:ring-destructive/30"
        >
          Remove
        </button>
      </div>
    </Modal>,
    document.body,
  )
}
